<ul class="list-none grid grid-cols-2 gap-1 max-w-96 mb-2">
  <ef-validation-check [status]="passwordPartsValidation().upperCase" i18n>wielka litera</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().lowerCase" i18n>mała litera</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().minLength" i18n>minimum 8 znaków</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().digitOrSpecial" i18n>
    cyfra lub znak spacjalny
  </ef-validation-check>
</ul>
